





























































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import { TutoreInfo } from "../../_models/tutoreInfo";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { RichiestaAlternanza } from "../../_models/richiestaAlternanza";
import DetailsDialog from "../Dialogs/DetailsDialog.vue";
import { RichiestaTirEstivi } from "../../_models/richiestaTirEstivi";
import { RichiestaTirFormativi } from "../../_models/richiestaTirFormativi";
import * as temp from "../../_store/temp.module";
import AssignEnterprise from "../AssignEnterprise.vue";

@Component({
  components: {
    DetailsDialog,
    AssignEnterprise
  }
})
export default class AssignDialog extends Vue {
  @Prop() params!: any;
  @Prop() info!: any;
  @Prop() activitytype!: string;
  @Prop() idRichiesta!: number;
  private dialog: boolean;
  private loadingData: boolean;
  private searchTutor: string;

  private tutorList: TutoreInfo[];

  constructor() {
    super();
    this.dialog = false;
    this.searchTutor = "";
    this.loadingData = true;
    this.tutorList = [];
  }

  get items() {
    var tutor: TutoreInfo;
    var tutorListTemp: TutoreInfo[] = [];
    var richiestaAlternanza: RichiestaAlternanza;
    var richiesteTemp: any = [];
    var richiestaTirEstivo: RichiestaTirEstivi;
    var idArticolazioneAllievo: string;
    var idIndirizzoStudio: number;
    var richiestaTirFormativo: RichiestaTirFormativi;
    if (this.params.assignmentType === "tutorAssignment") {
      idArticolazioneAllievo = this.info.idArticolazione;
      this.params.records.forEach((element: any) => {
        if (element.idArticolazione === idArticolazioneAllievo) {
          tutor = element;
          tutorListTemp.push(tutor);
        }
      });
      this.loadingData = false;
      return tutorListTemp;
    } else {
      if (this.activitytype === "alternanza") {
        idIndirizzoStudio = this.info.idIndirizzoStudio;
        this.params.records.forEach((element: any) => {
          if (element.idIndirizzoStudio === idIndirizzoStudio) {
            richiestaAlternanza = element;
            richiesteTemp.push(richiestaAlternanza);
          }
        });
        this.loadingData = false;
        // return richiesteTemp;
      } else if (this.activitytype === "tirocinioEstivo") {
        idIndirizzoStudio = this.info.idIndirizzoStudio;
        this.params.records.forEach((element: any) => {
          if (element.idIndirizzoStudio === idIndirizzoStudio) {
            richiestaTirEstivo = element;
            richiesteTemp.push(richiestaTirEstivo);
          }
        });
        this.loadingData = false;
      } else if (this.activitytype === "tirocinioFormativo") {
        idIndirizzoStudio = this.info.idIndirizzoStudio;
        this.params.records.forEach((element: any) => {
          if (element.idIndirizzoStudio === idIndirizzoStudio) {
            richiestaTirFormativo = element;
            richiesteTemp.push(richiestaTirFormativo);
          }
        });
        this.loadingData = false;
      }else if (this.activitytype === "tirocinioReIns") {
        idIndirizzoStudio = this.info.idIndirizzoStudio;
        this.params.records.forEach((element: any) => {
          if (element.idIndirizzoStudio === idIndirizzoStudio) {
            richiestaTirFormativo = element;
            richiesteTemp.push(richiestaTirFormativo);
          }
        });
        this.loadingData = false;
      }
      return richiesteTemp;
    }
  }

  assignTutor(idTutor: number) {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico,
      idAllievo: this.info.idUtente,
      idTutor: idTutor
    };
    user
      .dispatchAssignTutorToAllievo(this["$store"], payload)
      .then(() => {
        bus.$emit("successfullOperation", "Assegnazione avvenuta con successo");
        bus.$emit("loadSectorStudentsList");
        this.dialog = false;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  // assignEnterprise(idRichiesta: number, idRichiestaOld: number) {
  //   var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
  //   var instituteInfo = user.readInstituteInfo(this["$store"]);
  //   var userInfo = user.readUserInfo(this["$store"]);
  //   if (idRichiestaOld === null || idRichiestaOld === undefined) {
  //     idRichiestaOld = 0;
  //   }
  //   var payload = {
  //     idIstituto: instituteInfo.id,
  //     idAnnoScolastico: idAnnoScolastico,
  //     idAllievo: this.info.idUtente,
  //     idTutor: userInfo.idUtente,
  //     // idTutor:"",
  //     idRichiesta: idRichiesta,
  //     idRichiestaOld: idRichiestaOld,
  //     attivita: ""
  //   };
  //   var payload2 = {
  //     idAllievo: this.info.idUtente,
  //     idAnnoScolastico: idAnnoScolastico,
  //     idIstituto: instituteInfo.id
  //   };
  //   if (this.activitytype === "alternanza") {
  //     payload.attivita = "alternanza";
  //     data
  //       .dispatchDetailsAbbinamentoTutorAllievo(this["$store"], payload2)
  //       .then(result => {
  //         payload.idTutor = result.IdTutorArticolazione;
  //         user
  //           .dispatchAssignAllievoToAzienda(this["$store"], payload)
  //           .then(() => {
  //             bus.$emit(
  //               "successfullOperation",
  //               "Assegnazione avvenuta con successo"
  //             );
  //             this.dialog = false;
  //             bus.$emit("loadStudentsTutor");
  //             bus.$emit("loadSectorRequests");
  //           })
  //           .catch(error => {
  //             if (error.response.status === 403) {
  //               bus.$emit("errorOperation", error.response.statusText);
  //               this["$router"].push("/login");
  //             } else {
  //               bus.$emit("errorOperation", error.response.statusText);
  //             }
  //           });
  //       });
  //   } else if (this.activitytype === "tirocinioEstivo") {
  //     payload.attivita = "tirocinioEstivo";
  //     user
  //       .dispatchAssignAllievoToAziendaTirEstivo(this["$store"], payload)
  //       .then(() => {
  //         bus.$emit(
  //           "successfullOperation",
  //           "Assegnazione avvenuta con successo"
  //         );
  //         this.dialog = false;
  //         bus.$emit("loadStudentsTutor");
  //         bus.$emit("loadSectorRequests");
  //       })
  //       .catch(error => {
  //         if (error.response.status === 403) {
  //           bus.$emit("errorOperation", error.response.statusText);
  //           this["$router"].push("/login");
  //         } else {
  //           bus.$emit("errorOperation", error.response.statusText);
  //         }
  //       });
  //   } else if (this.activitytype === "tirocinioFormativo") {
  //     payload.attivita = "tirocinioFormativo";
  //     data
  //       .dispatchDetailsAbbinamentoTutorAllievo(this["$store"], payload2)
  //       .then(result => {
  //         payload.idTutor = result.IdTutorArticolazione;
  //         user
  //           .dispatchAssignAllievoToAziendaTirFormativo(this["$store"], payload)
  //           .then(() => {
  //             bus.$emit(
  //               "successfullOperation",
  //               "Assegnazione avvenuta con successo"
  //             );
  //             this.dialog = false;
  //             bus.$emit("loadStudentsTutor");
  //             bus.$emit("loadSectorRequests");
  //           })
  //           .catch(error => {
  //             if (error.response.status === 403) {
  //               bus.$emit("errorOperation", error.response.statusText);
  //               this["$router"].push("/login");
  //             } else {
  //               bus.$emit("errorOperation", error.response.statusText);
  //             }
  //           });
  //       });
  //   } else {
  //     bus.$emit(
  //       "errorOperation",
  //       "Errore nella procedura di assegnazione azienda"
  //     );
  //   }
  // }

  assignTutorForm(idTutorForm: number, idRichiesta: number) {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var userInfo = user.readUserInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico,
      idAllievo: this.info.idUtente,
      idTutor: userInfo.idUtente,
      idTutorForm: idTutorForm,
      idRichiesta: idRichiesta,
      attivita: ""
    };
    var payload2 = {
      idAllievo: this.info.idUtente,
      idAnnoScolastico: idAnnoScolastico,
      idIstituto: instituteInfo.id
    };
    data
      .dispatchDetailsAbbinamentoTutorAllievo(this["$store"], payload2)
      .then(result => {
        payload.idTutor = result.IdTutorArticolazione;
        if (this.activitytype === "alternanza") {
          payload.attivita = "alternanza";
          user
            .dispatchAssignTutorFormToRichiestaAlternanza(
              this["$store"],
              payload
            )
            .then(() => {
              bus.$emit(
                "successfullOperation",
                "Assegnazione avvenuta con successo"
              );
              this.dialog = false;
              bus.$emit("loadStudentsTutor");
              // bus.$emit("loadSectorRequests");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", error.response.statusText);
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", error.response.statusText);
              }
            });
        } else if (this.activitytype === "tirocinioEstivo") {
          payload.attivita = "tirocinioEstivo";
          user
            .dispatchAssignTutorFormToRichiestaTirEstivo(
              this["$store"],
              payload
            )
            .then(() => {
              bus.$emit(
                "successfullOperation",
                "Assegnazione avvenuta con successo"
              );
              this.dialog = false;
              bus.$emit("loadStudentsTutor");
              // bus.$emit("loadSectorRequests");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", error.response.statusText);
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", error.response.statusText);
              }
            });
        } else if (this.activitytype === "tirocinioFormativo") {
          payload.attivita = "tirocinioFormativo";
          user
            .dispatchAssignTutorFormToRichiestaTirFormativo(
              this["$store"],
              payload
            )
            .then(() => {
              bus.$emit(
                "successfullOperation",
                "Assegnazione avvenuta con successo"
              );
              this.dialog = false;
              bus.$emit("loadStudentsTutor");
              // bus.$emit("loadSectorRequests");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", error.response.statusText);
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", error.response.statusText);
              }
            });
        } else if (this.activitytype === "tirocinioReIns") {
          payload.attivita = "tirocinioFormativo";
          user
            .dispatchAssignTutorFormToRichiestaTirFormativo(
              this["$store"],
              payload
            )
            .then(() => {
              bus.$emit(
                "successfullOperation",
                "Assegnazione avvenuta con successo"
              );
              this.dialog = false;
              bus.$emit("loadStudentsTutor");
              // bus.$emit("loadSectorRequests");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", error.response.statusText);
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", error.response.statusText);
              }
            });
        } else {
          bus.$emit(
            "errorOperation",
            "Errore nella procedura di assegnazione tutor formativo"
          );
        }
      });
  }
}
